module.exports = __webpack_public_path__ + "static/jiri.367dbb70.png";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/AboutPage/PeopleSection/jiri.png
// module id = 1002
// module chunks = 0